import adminRequest from '@/utils/h5-admin-request'

const PREFIX = '/signstore/h5admin/signs'

export function fetchSignsStores(params) {
  return adminRequest.get(PREFIX + '/stores', { params })
}

export function fetchSignsUsers(params) {
  return adminRequest.get(PREFIX + '/users', { params })
}

export function fetchSignsActivities(params) {
  return adminRequest.get(PREFIX + '/activities', { params })
}

export function fetchSignsActivityOptions(params) {
  return adminRequest.get(PREFIX + '/activity-options', { params })
}

export function fetchSignsJoinRecords(params) {
  return adminRequest.get(PREFIX + '/join-records', { params })
}

export function fetchSignsCheckinLogs(params) {
  return adminRequest.get(PREFIX + '/checkin-logs', { params })
}

export function exportSignsCheckinLogs(activityId, params) {
  return adminRequest.get(PREFIX + '/activities/' + activityId + '/exportSealruleLogs', {
    params,
    responseType: 'blob',
    timeout: 120000
  })
}

export function exportSignsActivityUsers(activityId, params) {
  return adminRequest.get(PREFIX + '/activities/' + activityId + '/exportActivityUsers', {
    params,
    responseType: 'blob',
    timeout: 120000
  })
}
